import React from "react";

interface AeroSyncLogoProps {
  width?: number;
  height?: number;
  className?: string;
}

export function AeroSyncLogo({ width = 50, height = 50, className = "" }: AeroSyncLogoProps) {
  return (
    <svg 
      width={width} 
      height={height} 
      viewBox="0 0 50 50" 
      fill="none" 
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <rect width="50" height="50" rx="4" fill="#01266A"></rect>
      <path d="M44.485 34.3067C44.4033 34.2733 40.8133 32.805 35.4083 31.165L42.7667 5H36.6917C35.3667 5 34.1083 5.63833 33.3267 6.70833L21.9883 22.225C19.955 25.0067 16.6833 26.6667 13.24 26.6667H5V28.3333H9.16667C23.9317 28.3333 40.2517 34.435 43.3333 35.6417V36.025C40.2517 37.2317 23.9317 43.3333 9.16667 43.3333H5V45H9.16667C25.805 45 44.3 37.4367 44.485 37.36L45 37.1467V34.52L44.485 34.3067ZM18.1817 27.31C20.21 26.435 22.0017 25.0317 23.335 23.2083L34.6733 7.69167C35.1433 7.05 35.8983 6.66667 36.6933 6.66667H40.5667L33.81 30.69C29.3383 29.395 23.8633 28.07 18.1833 27.3083L18.1817 27.31ZM28.3333 35V36.6667H16.6667V35H28.3333Z" fill="white"></path>
    </svg>
  );
}

export function AeroSyncSimpleLogo({ width = 50, height = 50, className = "" }: AeroSyncLogoProps) {
  return (
    <svg 
      width={width} 
      height={height} 
      viewBox="0 0 50 50" 
      fill="none" 
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <rect width="50" height="50" rx="4" fill="#01266A"></rect>
      <path d="M41 33C41 33 28 28 14 28H5V33H14C28 33 41 38 41 38V33Z" fill="white"></path>
      <path d="M40 10H36L26 25C26 25 20 28 14 28" stroke="white" strokeWidth="2" strokeLinecap="round"></path>
      <path d="M28 35H17V37H28V35Z" fill="white"></path>
    </svg>
  );
}
